module.exports = __webpack_public_path__ + "fonts/Inter-ThinItalic.e08d9b2.woff2";